import * as shvl from 'shvl'

import en from '../../locales/en.default.json'
import es from '../../locales/es.json'

import type { Locale } from '@/types'

const LOCALES = {
  en,
  es
}

const interpolate = (string: string, values = {}) => {
  Object.entries(values).forEach(([ key, value ]: [ string, any ]) => {
    const regex = new RegExp(`{{ *${key} *}}`, 'g')
    string = string.replace(regex, String(value))
  })
  return string
}

export const translation = (key: string, locale: Locale, values = {}) => {
  const missing = `[translation missing]: ${key}`
  try {
    const obj = LOCALES[locale]
    const string = shvl.get(obj, key, missing)
    return interpolate(string, values)
  } catch {
    console.warn(missing)
    return missing
  }
}
